import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { getDecisionReport } from '@/utils/decisionReport';

export const procedureReportDecisionsRoute: RouteConfig = {
  path: 'reports/decision',
  name: 'procedureReportDecisions',
  component: () =>
    import(/* webpackChunkName: "ProcedureReports" */ '@/views/mainRoute/procedure/details/ReportDecisions.vue'),
  beforeEnter: (to, from, next) => {
    getDecisionReport(to)
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.REPORT_CANNOT_GET }));
  }
};
